export default __webpack_public_path__ + "b53050945f347fb559cd8fdc8f0f97c4.png";